import { apiURLV1 } from '../../config';

export const CalendarEventApiRoutes = {
  base: `${apiURLV1}/calendarEvents`,
};
